<span [ngClass]="classMap">
      <input
        #inputElement
        [checked]="dwChecked"
        type="checkbox"
        class="ant-checkbox-input"
        (blur)="onBlur()">
      <span class="ant-checkbox-inner"></span>
    </span>
<span #contentElement (cdkObserveContent)="checkContent()"><ng-content></ng-content></span>